import { Col, Row } from "antd";
import React from "react";
interface LinkItem {
  title: string;
  url: string;
}

interface LinkSection {
  title: string;
  links: LinkItem[];
}

const footerLinkSections: LinkSection[] = [
  {
    title: "Marketplace",
    links: [
      { title: "All NFTs", url: "http://virl.com/marketplace" },
      {
        title: "New",
        url: "https://virl.com/marketplace?sortBy=created&verified=true&whitelisted=true",
      },
      {
        title: "Verified",
        url: "https://virl.com/marketplace?whitelisted=false&verified=true",
      },
    ],
  },
  {
    title: "My Account",
    links: [
      { title: "Sign-In", url: "https://virl.com/" },
      { title: "Support", url: "https://virl.com/profile/support-ticket" },
    ],
  },
  {
    title: "Resources",
    links: [
      { title: "Blog", url: "https://wax-io.medium.com/" },
      {
        title: "Docs",
        url: "https://github.com/worldwide-asset-exchange/whitepaper",
      },
    ],
  },
  {
    title: "Company",
    links: [
      { title: "About", url: "http://on.wax.io/about-wax" },
      { title: "New", url: "https://virl.com/support" },
      { title: "FAQ", url: "https://virl.com/support" },
    ],
  },
];

export default function TopFooter() {
  return (
    <Row gutter={[0, 40]}>
      <Col xs={24} xl={8}>
        <Row gutter={[24, 24]}>
          <Col xs={24}>
            <img src="/image/home/logo-vertical.svg" alt="" />
          </Col>
          <Col xs={24}>
            <p style={{ color: "#777E90" }} className="w-font-md fw-600">
              The home of NFTs for the WAX Blockchain
            </p>
          </Col>
        </Row>
      </Col>
      <Col xs={24} xl={16}>
        <Row gutter={[24, 24]} justify={"start"}>
          {footerLinkSections.map((section) => (
            <Col xs={12} xl={5}>
              <Row className="w-font-md fw-600" gutter={[16, 16]}>
                <Col style={{ marginBottom: 8 }} xs={24}>
                  {section.title}
                </Col>
                {section.links.map((link) => (
                  <Col style={{ color: "#777E90" }} xs={24}>
                    <a target={"_blank"} href={link.url} rel="noreferrer">
                      {link.title}
                    </a>
                  </Col>
                ))}
              </Row>
            </Col>
          ))}
        </Row>
      </Col>
    </Row>
  );
}
